import { Button, Col, Form, Row, Space } from "antd";
import { observer } from "mobx-react-lite";

import { FormItem, FormSelect, FormSwitch } from "@/ui/_common_/form-helpers";

import ErrorsFormatter from "../_common_/errors-formatter";
import { FormSpinner } from "../_common_/form-spinner";

import { PSPSettingState } from "./form.state";

type Props = {
  state: PSPSettingState;
  readonly?: boolean;
};

export const PSPSettingView = observer<Props>(({ state, readonly }) => {
  const { intl, query, submitQuery, form, paymentGatewayQuery, resetQuery } =
    state;

  if (
    query.isIdle ||
    query.isPending ||
    paymentGatewayQuery.isIdle ||
    paymentGatewayQuery.isPending
  ) {
    return <FormSpinner />;
  }

  const options = paymentGatewayQuery.items.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  return (
    <Space direction="vertical">
      <ErrorsFormatter queries={[submitQuery]} />
      <Form
        labelCol={{ span: 8 }}
        labelAlign="left"
        wrapperCol={{ span: 16 }}
        layout="horizontal"
        onFinish={form.handleSubmit(submitQuery.submit)}
      >
        <FormItem
          form={form}
          path="paymentGateway.id"
          label={intl.formatMessage({
            defaultMessage: "PSP Gate ID",
          })}
        >
          <FormSelect
            form={form}
            path={"paymentGateway.id"}
            placeholder={intl.formatMessage({ defaultMessage: "Select PSP" })}
            options={options}
            disabled={readonly}
          />
        </FormItem>
        <FormItem
          form={form}
          path="lobbySettings.isDepositActive"
          label={intl.formatMessage({
            defaultMessage: "Deposit PSP",
          })}
        >
          <FormSwitch
            form={form}
            path="lobbySettings.isDepositActive"
            disabled={readonly}
          />
        </FormItem>
        <FormItem
          form={form}
          path="lobbySettings.isWithdrawActive"
          label={intl.formatMessage({ defaultMessage: "Withdraw PSP" })}
        >
          <FormSwitch
            form={form}
            path="lobbySettings.isWithdrawActive"
            disabled={readonly}
          />
        </FormItem>
        {!readonly && (
          <Row justify="end" gutter={12}>
            <Col>
              <Button
                type="default"
                htmlType="button"
                loading={resetQuery.isPending}
                disabled={submitQuery.isPending}
                onClick={resetQuery.submit}
              >
                {intl.formatMessage({ defaultMessage: "Reset" })}
              </Button>
            </Col>
            <Col>
              <Button
                type="primary"
                htmlType="submit"
                disabled={resetQuery.isPending}
                loading={submitQuery.isPending}
              >
                {intl.formatMessage({ defaultMessage: "Save" })}
              </Button>
            </Col>
          </Row>
        )}
      </Form>
    </Space>
  );
});
